import React, { FC } from 'react';

import './lineClamp.scss';

interface Props extends React.CSSProperties {
  numberOfLines: number;
}

const index: FC<Props> = ({ numberOfLines, hyphens, children }) => (
  <div style={{ WebkitLineClamp: numberOfLines, hyphens }} className="ui-components-line-clamp">
    {children}
  </div>
);

export default index;
